module.exports = __webpack_public_path__ + "img/brogues1.cac95d43.jpg";